module.exports = __webpack_public_path__ + "img/get_icon.ac8413f8.png";